/** Industry options for solution story forms — must match slide icon mappings / industries sheet. */
export const SOLUTION_STORY_INDUSTRY_OPTIONS = [
  'Financial Services & Insurance',
  'Healthcare and Life Sciences',
  'Travel, Transportation and Logistics',
  'Retail, CPG & E-Commerce',
  'Telecommunications, Media, Entertainment & Gaming',
  'Manufacturing, Industrials & Construction',
  'Technology, Software & Services',
  'Natural Resources, Energy and Utilities',
  'Public Sector & Education',
  'Other Industries',
] as const;

export type SolutionStoryIndustry = (typeof SOLUTION_STORY_INDUSTRY_OPTIONS)[number];
